import { makeStyles } from "@material-ui/core";
export var useStyles = makeStyles(function (theme) { return ({
    iconSx: {
        margin: "0px 2px 0 0",
        color: "#111629",
    },
    imageButton: {
        margin: "0px 2px 0 0",
        padding: "2px",
    },
    sectionDesktop: {
        display: "flex",
        "& .MuiListItem-button": {
            "&:hover": {
                backgroundColor: "transparent !important",
            },
        },
    },
    iconLogOut: {
        minWidth: "36px !important",
    },
    listItemText: {
        textDecoration: "none",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        fontSize: 12,
    },
    itemProfile: {
        width: 236,
        height: 93,
        borderRadius: "5px",
        boxShadow: theme.shadows[1],
        top: "42px !important",
        backgroundColor: theme.palette.background.paper,
        "&:hover": {
            backgroundColor: theme.palette.background.paper,
        },
    },
    role: {
        fontSize: 12,
    },
    large: {
        width: 24,
        height: 24,
    },
    divider: {
        marginTop: "0 !important",
        marginBottom: "0 !important",
    },
    avatar: {
        padding: "5px 5px 5px 8px",
    },
}); });
